import {ChangeEvent} from 'react';

export function prepareLicenseNumberFormat(event: ChangeEvent<HTMLInputElement>): string {
    return event?.target?.value !== undefined &&
    event?.target?.value !== null ?
        event?.target?.value.split(' ').join('').trim() : '';
}
